import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import { FormattedMessage } from 'ui/i18n';
import NumberFormat from 'react-number-format';
import './EditableNumber.scss';

@observer
export default class EditableNumber extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		value: PropTypes.number,
		isDisabled: PropTypes.bool,
		errorMsgId: PropTypes.string,
		availableQuantity: PropTypes.number,
		cartQuantity: PropTypes.number,
		onChangeHandler: PropTypes.func.isRequired,
		onBlurHandler: PropTypes.func.isRequired,
	};

	static defaultProps = {
		value: null,
		isDisabled: false,
		errorMsgId: null,
		availableQuantity: 0,
		cartQuantity: 0,
	};

	@observable hasErrorDuringChange = false;
	@observable changedQuantity = null;

	@computed
	get hasErrorMessage() {
		return this.hasErrorDuringChange || this.props.item.errorMsgId !== null;
	}

	get quantity() {
		return this.props.item.quantity_ordered || this.changedQuantity;
	}

	@action
	onChangeHandler(value, item) {
		this.props.onChangeHandler(value, item);
		this.hasErrorDuringChange = !!item.errorMsgId;
		this.changedQuantity = value;
	}

	render() {
		return (
			<div className="EditableNumber">
				<NumberFormat
					disabled={this.props.isDisabled}
					allowNegative={false}
					decimalScale={0}
					value={this.quantity}
					onBlur={() => this.props.onBlurHandler(this.props.item)}
					onValueChange={values =>
						this.onChangeHandler(values.floatValue, this.props.item)}
				/>

				{this.hasErrorMessage &&
					this.props.item.errorMsgId !== null &&
					<FormattedMessage
						className="error"
						id={this.props.item.errorMsgId}
						values={{
							quantity_in_cart: this.props.cartQuantity,
							available_quantity: this.props.availableQuantity,
							available_quantity_on_submit: this.props.item.quantity_available,
						}}
					/>}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/EditableNumber/index.js